interface State {
  errors: Error[];
}

interface Error {
  key: string;
  message: string;
}

export default {
  namespaced: true,
  state: {
    errors: [],
  } as State,
  mutations: {
    remove: (state: State, key: string): void => {
      state.errors.splice(
        state.errors.findIndex((x) => x.key === key),
        1
      );
    },
    clear: (state: State): void => {
      state.errors = [];
    },
    add: (state: State, { message, key }: Error): Error[] => {
      const target = state.errors.find((x) => x.key === key);

      if (!target) {
        state.errors.push({
          key,
          message,
        });
        return state.errors;
      }

      target.message = message;
      return state.errors;
    },
  },
  getters: {
    find:
      (state: State) =>
      (key: string): string => {
        const error = state.errors.find((x) => x.key === key);

        return error ? error.message : "";
      },
    first: (state: State): string => {
      if (!state.errors.length) {
        return "";
      }

      return state.errors[0].message;
    },
    allMessages(state: State): string {
      return state.errors.map((x) => x.message).join("<br />");
    },
  },
};
